import { render, staticRenderFns } from "./InformeActividad.vue?vue&type=template&id=30283ed2&scoped=true&"
import script from "./InformeActividad.vue?vue&type=script&lang=ts&"
export * from "./InformeActividad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30283ed2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('30283ed2', component.options)
    } else {
      api.reload('30283ed2', component.options)
    }
    module.hot.accept("./InformeActividad.vue?vue&type=template&id=30283ed2&scoped=true&", function () {
      api.rerender('30283ed2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ProgramacionInforme/TiposdeInformes/TipoInformeActividad/InformeActividad.vue"
export default component.exports